export default {"src":"/_next/static/media/home-picture.2ca755bc.svg","height":526,"width":607,"blurWidth":0,"blurHeight":0};